import { WebClientListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '~src/httpClient/resources/ResourceQuery';

import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { DeleteWorkbookVersionsRequest } from '../../workbook/ServerApi/requests/DeleteWorkbookVersionsRequest';
import { GetWorkbookVersionsRequest, IGetWorkbookVersionsResult } from '../serverApi/requests/getWorkbookVersionsRequest';
import { IWorkbookRevision } from '../serverApi/types/IWorkbookRevision';

class WorkbookRevisions {

  private fetcher = new WebClientListResourceFetcher<IWorkbookRevision, IGetWorkbookVersionsResult>(
    GetWorkbookVersionsRequest,
    (result: IGetWorkbookVersionsResult) => result.versions);

  public del = (id: string): Promise<IResult> => {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests([id], (idsBlock) => new DeleteWorkbookVersionsRequest(idsBlock)),
      ResultHelper.combineResults);
  };

  public all(): ResourceQuery<IWorkbookRevision> {
    return new ResourceQuery(this.fetcher);
  }

}

export const WorkbookRevisionsInstance = new WorkbookRevisions();
export type {WorkbookRevisions};

